var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-graph',{attrs:{"chartData":_vm.chartData,"ratesSwitchLabel":_vm.ratesSwitchLabel,"instructionsCard":_vm.instructionsCard,"repositionSpeedDial":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }